import React from "react";
import useEbook from "./useEbook";
import Ebook from "./Components/Ebook";

const EbookIndex: React.FC = () => {

  return <Ebook />;
};
export default EbookIndex;
